import React from 'react';
import { JiraIssueCreateErrorBoundary } from '@atlassian/jira-issue-create-analytics-common/src/ui/jira-issue-create-error-boundary/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { Props } from './ui/modal/types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const FindFieldModal = lazy(
	() => import(/* webpackChunkName: "async-issue-config-find-field" */ './ui/modal/index.tsx'),
	{ ssr: false },
);

const LazyFindFieldModal = (props: Props): React.JSX.Element => (
	<JiraIssueCreateErrorBoundary
		id="AsyncFindFieldModal"
		packageName="jiraIssueConfigFindField"
		fallback="flag"
		sendToPrivacyUnsafeSplunk
	>
		<Placeholder name="config-find-field-modal" fallback={<></>}>
			<FindFieldModal {...props} />
		</Placeholder>
	</JiraIssueCreateErrorBoundary>
);

export default LazyFindFieldModal;
